/**
 * The sign-in cover (proto/auth, stars.css §18): the starfield art column with the
 * STARS wordmark and, where a page has it, its marketing lines, beside the form column.
 * Five pages use it (login, signup, verify-code, forgot, reset). The form column holds
 * `children` in a 384px box.
 * PasswordInput is the show/hide password control shared by login and reset.
 */
import React, { forwardRef } from "react";
import { Link } from "react-router-dom";
import { Button, Input, Logo, cn } from "../ui";
import StarsIcon from "../../styles/StarsIcon";

export function AuthCover({ art, logoTo, children }) {
  const logo = <Logo className="tw-w-52" />;
  return (
    <div data-slot="login-signup-wrap" className="stars-dark tw-grid tw-min-h-screen tw-bg-overlay-navy tw-font-sans tw-text-text rail:tw-grid-cols-2">
      <section
        aria-label="STARS"
        className="tw-relative tw-grid tw-content-between tw-gap-4 tw-bg-starfield tw-bg-cover tw-bg-center tw-p-8 rail:tw-sticky rail:tw-top-0 rail:tw-h-screen max-rail:tw-min-h-80"
      >
        <div>{logoTo ? <Link to={logoTo}>{logo}</Link> : logo}</div>
        {art ? <div>{art}</div> : <div />}
      </section>
      <main className="tw-grid tw-place-items-center tw-px-6 tw-py-12">
        <div className="tw-w-full tw-max-w-sm">{children}</div>
      </main>
    </div>
  );
}

export function AuthHeading({ title, lede }) {
  return (
    <>
      <h1 className={cn("tw-m-0 tw-text-2xl tw-font-bold tw-text-text", !lede && "tw-mb-6")}>{title}</h1>
      {lede && <p className="tw-mb-6 tw-mt-2 tw-text-sm tw-text-text-muted">{lede}</p>}
    </>
  );
}

export const PasswordInput = forwardRef(function PasswordInput(
  { shown, onToggle, className, ...props },
  ref,
) {
  return (
    <div className="tw-relative">
      <Input ref={ref} type={shown ? "text" : "password"} className={cn("tw-pr-12", className)} {...props} />
      <Button
        variant="icon"
        iconOnly
        size="sm"
        className="tw-absolute tw-inset-y-0 tw-right-2 tw-my-auto tw-border-transparent"
        aria-label={shown ? "Hide password" : "Show password"}
        onClick={onToggle}
      >
        <StarsIcon name={shown ? "eyeOff" : "eye"} className="tw-h-5 tw-w-5 tw-shrink-0" />
      </Button>
    </div>
  );
});
